/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
  const targetElement = document.getElementById("FreeShippingBanner");
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (addedNode) {
        if (!addedNode) return;
        const globaE = addedNode?.querySelector("#FreeShippingBanner");
        if (globaE) {
          const barMsg = document.querySelector(".toolbar__custom-text");
          if (barMsg) {
            barMsg.innerHTML = globaE.innerHTML;
            globaE.style.display = "none";
            observer.disconnect();
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    subtree: false,
    childList: true,
  });
})();

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector("[id^='ModalClose-']")?.addEventListener(
      "click",
      this.hide.bind(this)
    );
    document.addEventListener("keydown", (evt) => {
      if (evt.key === "Escape") {
        this.hide();
      }
    });
    this.addEventListener("click", (event) => {
      if (event?.target.classList.contains("modal-overlay")) this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);
